import { Stack, Tooltip } from '@data-products-and-ai/react-components';
import { FC, useMemo } from 'react';

import '@/pages/Outages/components/RiskWarning/RiskWarning.scss';

interface RiskWarningProps {
  highRiskCount: number;
  midRiskCount: number;
}

export const RiskWarning: FC<RiskWarningProps> = ({
  highRiskCount,
  midRiskCount,
}) => {
  const chips = useMemo(() => {
    return [
      {
        key: 'warn',
        count: midRiskCount,
        color: 'yellow',
        position: highRiskCount === 0 ? 'danger' : 'warn',
        tooltip: `There are ${midRiskCount} millwright(s) with elevated risk scores that should be checked.`,
      },
      {
        key: 'danger',
        count: highRiskCount,
        color: 'red',
        position: 'danger',
        tooltip: `There are ${highRiskCount} millwright(s) with very high risk scores requiring immediate attention.`,
      },
    ].filter((chip) => chip.count > 0);
  }, [highRiskCount, midRiskCount]);

  return (
    <div className="risk-warning">
      <Stack direction="row" horizontalAlign="center">
        {chips.map(({ key, count, color, position, tooltip }) => (
          <div
            key={key}
            className={`risk-warning__chip risk-warning__chip--${position}`}
          >
            <Tooltip title={tooltip} arrow>
              <div className={`risk-chip risk-chip--${color}`}>{count}</div>
            </Tooltip>
          </div>
        ))}
      </Stack>
    </div>
  );
};
